import React from 'react';
import { ProcessingIndicatorProps } from '../types/InterviewComponents';
import { ThinkingLabel } from './ThinkingLabel';
import './ProcessingIndicator.css';

const ProcessingIndicator: React.FC<ProcessingIndicatorProps> = ({
  isVisible,
  placement = 'inline',
  variant = 'thinking',
}) => {
  if (!isVisible) {
    return null;
  }

  const placementClass =
    placement === 'globe' ? 'processing-indicator processing-indicator--globe' : 'processing-indicator';

  return (
    <div className={placementClass} role="status" aria-live="polite">
      <ThinkingLabel variant={variant} />
    </div>
  );
};

export default ProcessingIndicator;
